// extracted by css-extract-rspack-plugin
export default {"iconsContainer":"_b0aaa8f","iconWrapper":"_cbe3d948","icon":"_4005db3b","heartPill":"_9c219523"};